<template>
      <div>
             <div class="row">
                <div class="col-xs-12">
                  <flCabecalhoForm
                    cls="print-titulo-form-20"
                    :texto="_traducao('global', 'roteiro')"
                  />
                </div>
              </div>
        
              <div class="row" v-if="form.aeronave.id_aeronave != 0">
                <div class="col-xs-12">
                  <div v-for="(itemRot, idxRot) in form.aeronave.roteiro" :key="idxRot">
                    <div class="row" style="margin-bottom: 10px; margin-top: 10px">
                      <!-- PARTIDA -->
                      <div
                        class="col-xs-12"
                        :class="{
                          'col-md-6': !exibeRoteiro(itemRot),
                          'col-md-5': exibeRoteiro(itemRot)
                        }"
                      >
                        <div class="text-center">
                          <span style="margin-bottom: 0px">{{
                            _traducao('global', 'partida').toUpperCase()
                          }}</span>
                        </div>
                        <div class="trecho-borda" style="min-height: 150px">
                          <div class="row">
                            <div class="col-xs-8">
                              <small>{{ itemRot.estado_partida }}</small>
                              <br />
                              {{ itemRot.cidade_partida
                              }}<i
                                class="fa fa-fw fa-angle-right"
                                aria-hidden="true"
                              ></i
                              ><small>{{ itemRot.designativo_partida }}</small>
                              <span v-if="itemRot.descricao_partida != ''">
                                ({{ itemRot.descricao_partida }})</span
                              ><br />
                              <small
                                v-html="itemRot.clima_partida"
                                style="text-transform: capitalize"
                              ></small>
                              <br />
                              <small v-html="itemRot.vento_partida"></small>
                              <br />
                              <span v-if="!exibeRoteiro(itemRot)">
                                {{ _traducao('global', 'decolagem') }} às
                                {{ itemRot.decolagem_hora }}
                              </span>
                            </div>
        
                            <div class="col-xs-4 text-center" style="padding-top: 13px">
                              <img :src="itemRot.img_partida" alt="" /><br />
                              <small v-html="itemRot.temperatura_partida"></small>
                            </div>
                          </div>
        
                          <hr />
        
                          <div class="row" v-if="exibeRoteiro(itemRot)">
                            <div class="col-xs-4 text-center">
                              <label>{{ _traducao('global', 'decolagem') }}</label
                              ><br />
                              {{ itemRot.decolagem_hora }}
                            </div>
        
                            <div class="col-xs-4 text-center">
                              <label
                                >{{ _traducao('global', 'nascer') }}
                                <i class="fa fa-sun-o" aria-hidden="true"></i></label
                              ><br />
                              {{ itemRot.nascer_partida | apPmTo24 }}
                            </div>
        
                            <div class="col-xs-4 text-center">
                              <label
                                >{{ _traducao('global', 'por') }}
                                <i class="fa fa-sun-o" aria-hidden="true"></i></label
                              ><br />
                              {{ itemRot.por_partida | apPmTo24 }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- TOTAIS -->
                      <div
                        class="col-xs-12 col-md-2"
                        v-if="exibeRoteiro(itemRot)"
                        :style="{padding: _isMobile ? '15px' : '0px'}"
                      >
                        <div class="text-center">
                          <span style="margin-bottom: 0px"
                            >{{ itemRot.decolagem_data }}
                          </span>
                        </div>
                        <div class="trecho-borda" style="min-height: 150px">
                          <div class="row">
                            <div class="col-xs-6 text-center" style="margin-top: 10px">
                              <label>{{ _traducao('registroDadosVoo', 'proa') }}</label
                              ><br />
                              {{ itemRot.proa }}
                            </div>
        
                            <div class="col-xs-6 text-center" style="margin-top: 10px">
                              <label>{{ _traducao('global', 'distancia') }}</label
                              ><br />
                              {{ itemRot.distancia | adicionaMN }}
                            </div>
                            <div class="col-xs-6 text-center" style="margin-top: 10px">
                              <label>Combustível</label><br />
                              {{ itemRot.combustivel }}L
                            </div>
        
                            <div
                              class="col-xs-6 text-center"
                              :class="{
                                'text-danger': itemRot.autonomia < 0
                              }"
                              style="margin-top: 10px"
                            >
                              <label>{{ _traducao('global', 'autonomia') }}</label
                              ><br />
                              <div class="text-center" v-if="idxRot == 0">
                                <span style="cursor: pointer">
                                  {{ itemRot.autonomia }}
                                  <!-- <i v-show="!fechado" class="fa fa-fw fa-refresh"></i> -->
                                </span>
                              </div>
        
                              <div v-if="idxRot != 0">{{ itemRot.autonomia }}</div>
                            </div>
        
                            <div class="col-xs-12 text-center" style="margin-top: 10px">
                              <label>{{ _traducao('global', 'tempoEstimado') }}</label
                              ><br />
                              {{ itemRot.tempo | decimalEmTempo2 }}
                            </div>
                          </div>
                        </div>
                      </div>
        
                      <!-- DESTINO -->
                      <div
                        class="col-xs-12"
                        :class="{
                          'col-md-6': !exibeRoteiro(itemRot),
                          'col-md-5': exibeRoteiro(itemRot)
                        }"
                      >
                        <div class="text-center">
                          <span style="margin-bottom: 0px">{{
                            _traducao('global', 'destino').toUpperCase()
                          }}</span>
                        </div>
                        <div class="trecho-borda" style="min-height: 150px">
                          <div class="row">
                            <div class="col-xs-8">
                              <small>{{ itemRot.estado_destino }}</small>
                              <br />
                              {{ itemRot.cidade_destino
                              }}<i
                                class="fa fa-fw fa-angle-right"
                                aria-hidden="true"
                              ></i
                              ><small v-if="itemRot.designativo_destino">{{
                                itemRot.designativo_destino.sigla
                              }}</small>
                              <span v-if="itemRot.descricao_destino != ''">
                                ({{ itemRot.descricao_destino }})</span
                              ><br />
                              <small
                                v-html="itemRot.clima_destino"
                                style="text-transform: capitalize"
                              ></small
                              ><br />
                              <small v-html="itemRot.vento_destino"></small>
                              <br />
                            </div>
        
                            <div class="col-xs-4 text-center" style="padding-top: 13px">
                              <img :src="itemRot.img_destino" alt="" /><br />
                              <small v-html="itemRot.temperatura_destino"></small>
                            </div>
                          </div>
        
                          <hr />
        
                          <div class="row" v-if="exibeRoteiro(itemRot)">
                            <div class="col-xs-4 text-center">
                              <label>{{ _traducao('global', 'pouso') }}</label
                              ><br />
                              {{ itemRot.pouso | formataTempo }}
                            </div>
        
                            <div class="col-xs-4 text-center">
                              <label
                                >{{ _traducao('global', 'nascer') }}
                                <i class="fa fa-sun-o" aria-hidden="true"></i></label
                              ><br />
                              {{ itemRot.nascer_destino | apPmTo24 }}
                            </div>
        
                            <div class="col-xs-4 text-center">
                              <label
                                >{{ _traducao('global', 'por') }}
                                <i class="fa fa-sun-o" aria-hidden="true"></i></label
                              ><br />
                              {{ itemRot.por_destino | apPmTo24 }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
        
                    <div class="row text-center" v-if="_isMobile">
                      <div class="col-xs-12">
                        <i
                          class="fa fa-chevron-down"
                          style="color: #1976d2; font-size: 18px"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                  </div>
        
                  <div class="row">
                    <div class="col-xs-12 col-md-12">
                      <div class="text-center">
                        <span style="margin-bottom: 0px">{{
                          _traducao('global', 'totais').toUpperCase()
                        }}</span>
                      </div>
                      <div class="trecho-borda" style="min-height: 60px">
                        <div class="row">
                          <div class="col-xs-4 text-center">
                            <label>{{
                              _traducao('global', 'distanciaTotal').toUpperCase()
                            }}</label
                            ><br />
                            {{ form.aeronave.distanciaTotal | adicionaMN }}
                          </div>
        
                          <div class="col-xs-4 text-center">
                            <label>{{
                              _traducao('global', 'consumoTotal').toUpperCase()
                            }}</label
                            ><br />
                            {{ Number(this.form.aeronave.combustivelTotal).toFixed(2) }}
                            L
                          </div>
        
                          <div class="col-xs-4 text-center">
                            <label>{{
                              _traducao('global', 'tempoTotal').toUpperCase()
                            }}</label
                            ><br />
                            {{ form.aeronave.tempoTotal | decimalEmTempo2 }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
      </div>
</template>
<script>
import Cadastro from '../mixins/cadastro.js'
export default {
	mixins: [Cadastro],
	props: {
		form: {
			type: Object,
			required: true
		},
	}
}
</script>